var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenpencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 309,
    viewBox: "0 0 390 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.1604,
    y: 136.95,
    width: 33,
    height: 150.109,
    transform: "rotate(-101.509 31.1604 136.95)",
    fill: "#FFD770"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3212,
    y: 138.546,
    width: 33,
    height: 23,
    rx: 4,
    transform: "rotate(-101.509 23.3212 138.546)",
    fill: "#E79E9C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 209.415,
    y: 94.301,
    width: 33,
    height: 158.313,
    transform: "rotate(-34.66 209.415 94.301)",
    fill: "#FFD770"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.235 214.977C329.289 211.654 328.342 208.283 326.308 205.341C321.126 197.845 310.848 195.97 303.353 201.153C295.857 206.335 293.982 216.613 299.164 224.108C301.199 227.051 304.018 229.127 307.146 230.25L334.063 245.57L329.235 214.977Z",
    fill: "#FFF3D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.806 230.271C329.495 230.237 327.151 230.897 325.105 232.311C323.059 233.726 321.614 235.686 320.829 237.86L334.204 245.472L331.806 230.271Z",
    fill: "#1E120B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.791 35.6546L189.289 48.7319L179.08 50.0641L178.213 40.0393L184.791 35.6546Z",
    fill: "#FFD770"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.406 59.4052L199.095 71.1439L191.622 64.0617L198.854 57.0658L206.406 59.4052Z",
    fill: "#FFD770"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.807 57.5292L219.114 55.5924L222.567 45.8932L231.891 49.6768L232.807 57.5292Z",
    fill: "#FFD770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenpencil);
export default __webpack_public_path__ + "static/media/brokenpencil.eded3c42bde88790a011eaae78c88b23.svg";
export { ForwardRef as ReactComponent };